<template>     
  <div class="col-12 itemNameInner 1" >
    <h1>      
      {{ varitemname }}
    </h1>
  </div>
</template>
<script>
export default { 
    name: "item-variation-name", 
    inject: {
        itemId: {
            default: null
        }
    },
    computed: {
        currentVariation() {
            return this.$store.getters[`${this.itemId}/currentItemVariation`];
        },
        propertyName(){
          var valName = "";
          $.each( this.currentVariation.variationProperties, function( index, group ){
              if(group.id == 2){
                $.each( group.properties, function( index2, value2 ){
                  if(value2.id == 597){
                    valName = value2.values.value;            
                  }
                  else{
                    valName = "";
                  }
                });
            }
            else{
              valName = "";
            }
          }); 
          return valName;
        },
        varitemname() {
          var outputName = "";
          if (this.propertyName.length > 0){
            outputName = this.propertyName;
          }
          else{
            if (this.currentVariation.variation.name.length > 0){
              outputName = this.currentVariation.variation.name;
            }
            else{
              outputName = this.currentVariation.texts.name1;
            }         
          }          
          return outputName;          
        }
    }
}
</script>
